import ConfirmModal from 'projectSections/sections/manage3/common/ConfirmModal'
import { useTranslate } from 'ra-core'
import React, { useState } from 'react'
import { useStudioSignals } from 'Studio/signals/useStudioSignals'
import { toCapitalise } from 'util/misc'

interface DeleteConfirmationData {
  object: any
  onConfirm: () => void
}

interface DialogProps {
  open: boolean
  setOpen: (open: boolean) => void
  title: string
  handleDelete: (e: any) => void
}

const DeleteConfirmationDialog: React.FC = () => {
  const translate = useTranslate()
  const [isOpen, setIsOpen] = useState(false)
  const [object, setObject] = useState<any | null>(null)
  const [onConfirm, setOnConfirm] = useState<(() => void) | null>(null)

  useStudioSignals(
    ({ object, onConfirm }: DeleteConfirmationData) => {
      setIsOpen(true)
      setObject(object)
      setOnConfirm(() => onConfirm)
    },
    ['requestDeleteConfirmation']
  )

  const handleDelete = (e: any) => {
    if (onConfirm) {
      onConfirm()
    }
    handleClose()
  }

  const handleClose = () => {
    setIsOpen(false)
    setObject(null)
    setOnConfirm(null)
  }

  const objectName = object?.getName?.() || ''

  return (
    <ConfirmModal
      open={isOpen}
      setOpen={(open: boolean) => {
        if (!open) {
          handleClose()
        }
      }}
      handleSubmit={handleDelete}
      title={translate('Delete %{object}', { object: toCapitalise(translate(objectName)) })}
      mainText={translate('Are you sure you want to delete this %{object}?', { object: translate(objectName) })}
      submitBtnLabel={translate('Yes, delete')}
      submitBtnProps={{ variant: 'contained', color: 'error', autoFocus: true }}
    />
  )
}

export default DeleteConfirmationDialog
